<template>
  <div>
    <nav-top Title="注册LULUTV"></nav-top>
    <field-text
        label="用户名"
        style="margin: 15px 0;"
        placeholder="请输入用户名"
        ref = "user"
        @contentWatch="res => model.username = res"
    />
    <field-text
        label="密码"
        style="margin: 15px 0;"
        placeholder="请输入密码"
        type="password"
        ref = "password"
        @contentWatch="res => model.pwd = res"
    />
    <field-text
        label="确认密码"
        style="margin: 15px 0;"
        placeholder="请再次输入密码"
        type="password"
        ref = "checkPwd"
        @contentWatch="res => model.checkpwd = res"
    />
    <field-text
        label="用户邮箱"
        style="margin: 15px 0;"
        placeholder="请输入邮箱地址"
        ref = "mail"
        @contentWatch="res => model.email = res"
    />
    <verify-code
        ref = "verify"
        @captchaWatch = "res=>model.captcha=res"
        @captchaToken = "res=>model.captchaToken=res"
    />
    <login-btn
        msg = "登录"
        msg2 = "注册"
        @login="$router.push('/login')"
        @register="register"
    />
  </div>
</template>

<script>
import NavTop from "@/components/common/NavTop";
import FieldText from "@/components/common/FieldText"
import VerifyCode from "@/components/common/VerifyCode";
import LoginBtn from "@/components/common/LoginBtn";
import {showFailToast, showLoadingToast} from "vant";
import {getUserInfo} from "@/utils/http";
import {handleError} from '@/utils/ecode';

export default {
  data() {
    return {
      model:{},
    }
  },
  name: "registerPage",
  components:{
    NavTop,
    FieldText,
    VerifyCode,
    LoginBtn,
  },
  methods:{
    async register() {
      if (!this.validateForm()) {
        return;
      }

      let toast = showLoadingToast({
        message: '注册中...',
        forbidClick: true,
      });

      let data = {
        'token': this.model.captchaToken,
        'code': this.model.captcha,
        'userid': this.model.username,
        'email': this.model.email,
        'appid': 1,
        'pwd': this.model.pwd
      };

      try {
        const res = await this.$user_http.post("/user/register", data);
        console.log(data);

        if (res.data.code === 0) {
          const token = res.data.data.token;
          const refreshToken = res.data.data.refresh;
          const expiry = new Date().getTime() + 3600 * 1000 * 24 * 7// 假设 token 有效期为1小时
          this.$store.commit('setToken', {token:token, refreshToken:refreshToken, expiry:expiry})
          const code = await getUserInfo();
          if (code === 0) {
            toast.close();
            let path = sessionStorage.getItem('redirectPath') || '/';
            sessionStorage.removeItem('redirectPath');
            this.$router.push(path);
            return;
          }
        } else {
          handleError(res.data.code, this.$refs.verify);
        }
      } catch (error) {
        showFailToast("网络链接失败!请检查网络！或稍后再试");
        console.error('Error fetching data:', error);
      }
    },
    validateForm() {
      const regx = /^.{6,16}$/;
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const captchaRegex = /^[a-zA-Z0-9]{4,5}$/;

      if (!this.model.username) {
        this.setError(this.$refs.user, "用户名不能为空");
        return false;
      }
      if (!this.model.pwd || !regx.test(this.model.pwd)) {
        this.setError(this.$refs.password, "请输入6~16位的密码");
        return false;
      }
      if (this.model.pwd !== this.model.checkpwd) {
        this.setError(this.$refs.checkPwd, "确认密码不一致");
        return false;
      }
      if (!emailRegex.test(this.model.email)) {
        this.setError(this.$refs.mail, "请输入正确的邮箱格式");
        return false;
      }
      if (!captchaRegex.test(this.model.captcha)) {
        this.setError(this.$refs.verify, "验证码不正确");
        return false;
      }

      return true;
    },
    setError(ref, errMsg) {
      ref.err = true;
      ref.content = "";
      ref.errMsg = errMsg;
    },
  }
}


</script>


